import commonAction from "./commonAction";
import API from "../api";

const api = new API();

export const loadFilters = filter => {
  const body = {
    filter
  };
  return dispatch =>
    commonAction(dispatch, "post", "/filter", body, "FILTERS_LOAD", "data");
};



// WEBPACK FOOTER //
// ./actions/filtersAction.js